import { PostcodeLookup } from '../classes/postcode-lookup';

export default (catId, enquiryType) => ({
	open: false,
	catId: catId,
	enquiryType: enquiryType,
	topics: [],
	showForm: false,
	formEnquirySectorField: '',
	formClosestLocationField: '',
	checkboxes: null,
	heading: false,
	submitSuccess: false,
	form: null,
	postcodeLookupField: null,
	closestDepot: false,
	closestTel: '',
	closestTelLink: '',
	noMatch: false,
	init() {
		this.$root.querySelector(
			"form input[name='enquiryType']"
		).value = this.enquiryType;
		this.formEnquirySectorField = this.$root.querySelector(
			"form input[name='enquirySector']"
		);
		this.formClosestLocationField = this.$root.querySelector(
			"form input[name='closestLocation']"
		);

		this.checkboxes = this.$root.querySelectorAll("input[type='checkbox']");

		this.form = this.$root.querySelector('form');
		if (this.form) {
			this.form.addEventListener('wpcf7mailsent', (e) => {
				this.submitSuccess = true;
			});
		}

		this.postcodeLookupField = this.$root.querySelector(
			'input[name="postcode_lookup"]'
		);
		if (this.postcodeLookupField) {
			this.postcodeLookupField.addEventListener('input', (e) => {
				this.doPostcodeLookup(e);
			});
		}
	},
	openCategory() {
		this.open = true;
	},
	closeCategory() {
		this.open = false;
		setTimeout(() => {
			this.form.reset();
			this.checkboxes.forEach((v, i, a) => {
				v.checked = false;
				v.closest('label').classList.remove('bg-gray-200');
			});
			this.topics = [];
			this.showForm = false;
			this.submitSuccess = false;
		}, 200);
	},
	topicClick(subCatId, multi) {
		const subCatHeading = document.getElementById(
			'sub-cat-heading-' + this.catId + '-' + subCatId
		).innerText;
		const checkbox = document.getElementById(
			'topics-' + this.catId + '-' + subCatId
		);
		let label = this.$root.querySelector(
			'label[for="topics-' + this.catId + '-' + subCatId + '"]'
		);

		if (checkbox.checked) {
			label.classList.add('bg-gray-200');
			if (!!multi) {
				this.topics.push(subCatHeading);
			} else {
				this.checkboxes.forEach((v, i, a) => {
					if (v != checkbox) {
						v.checked = false;
						v.closest('label').classList.remove('bg-gray-200');
					}
				});
				this.topics = [subCatHeading];
			}
		} else {
			label.classList.remove('bg-gray-200');
			this.topics = this.topics.filter((e) => {
				return e !== subCatHeading;
			});
		}

		this.formEnquirySectorField.value = this.topics.join(',');

		if (this.topics.length && !!!multi) {
			this.heading = subCatId;
		} else {
			this.heading = false;
		}

		this.checkFormStatus();
	},
	checkFormStatus() {
		if (this.topics.length) {
			if (!this.showForm) {
				setTimeout(() => {
					this.$refs.formContainer.scrollIntoView({
						behavior: 'smooth',
					});
				}, 500);
			}
			this.showForm = true;
		} else {
			this.showForm = false;
		}
	},
	doPostcodeLookup(e) {
		const Postcode = new PostcodeLookup(e.target) || {};
		if (Postcode.noMatch) {
			this.noMatch = true;
			this.closestTel = Postcode.closestLocation.tel;
			this.closestTelLink = 'tel:' + this.closestTel.replaceAll(' ', '');
		} else if (!_.isEmpty(Postcode.closestLocation)) {
			this.noMatch = false;
			this.closestDepot = Postcode.closestLocation.name;
			this.closestTel = Postcode.closestLocation.tel;
			this.closestTelLink = 'tel:' + this.closestTel.replaceAll(' ', '');
		} else {
			this.noMatch = false;
			this.closestDepot = false;
			this.closestTel = '';
			this.closestTelLink = '';
		}
	},
});
